getLocalState